import { Modal, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddEditUserForm from './AddEditUserForm';
import * as yup from 'yup';
import { useGetAllCenters } from '../../../lib/react-query/centerQuery';
import GlobalSpinner from '../../../Components2/common/GlobalSpinner';
import useCreateUser from './useCreateUser';
const OPEN = true;

const validationSchema = yup.object().shape({
  name: yup.string().required('El nombre es obligatorio'),
  email: yup
    .string()
    .required('El email es obligatorio')
    .transform((value) => value.toLowerCase().trim())
    .email('El email es invalido'),
  centers: yup.array().min(1, 'Debes seleccionar al menos un centro').required('Debes seleccionar al menos un centro'),
});

const AddUser = () => {
  const navigate = useNavigate();
  const handleOnClose = () => {
    navigate('../');
  };

  const { data, isLoading } = useGetAllCenters();
  const { mutateAsync, isLoading: isPending } = useCreateUser();

  return (
    <Modal open={OPEN} onClose={handleOnClose}>
      <div className="create-center-container-modal">
        {!isLoading ? (
          <div className="center-form-title">
            <Typography
              variant="h4"
              component="h2"
              align="center"
              sx={{ fontWeight: 'bold', marginBottom: '1.5rem', backgroundColor: '#3C4145', color: 'white' }}
            >
              CREAR USUARIO
            </Typography>

            <AddEditUserForm
              centers={data?.data}
              validationSchema={validationSchema}
              initialValues={{ email: '', name: '', centers: [], roles: ['user'] }}
              mutateAsync={mutateAsync}
              handleOnClose={handleOnClose}
              isPending={isPending}
            />
          </div>
        ) : (
          <div className="spinner-container">
            <GlobalSpinner />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AddUser;
